<template lang="pug">
.filtering__items
	.filtering__group(v-if="useFormGroupings")
		div(v-for="formType in formTypes")
			h3.filtering__form-type {{ formType }}
			TransitionShuffle
				Item(
					v-for="item in listing",
					v-if="item.visible && matchesType(item, formType)",
					:item="item.html", 
					:key="item.html")
				.filtering__empty(v-if="groupEmpty(formType)", :key="'empty'") There are no forms of this type available for your current selections.
	TransitionShuffle(v-else)
		Item(
			v-for="item in listing",
			v-if="item.visible",
			:item="item.html", 
			:key="item.html")
		.filtering__empty(v-if="empty", :key="'empty'") There are no forms available for your current selections.
</template>

<script>
import TransitionShuffle from "../transitions/Shuffle";
import Item from "./Item.vue";

import {mapGetters, mapMutations} from 'vuex';
export default {
	name: "FilteringItems",
	props: ["items"],
	components: {
		Item,
		TransitionShuffle,
	},
	computed: {
		...mapGetters(['model', 'search', 'formTypes', 'weightedSort']),
		empty() {
			return this.listing.every(item => item.visible === false);
		},
		listing() {
			// refactor this
			const items = this.items.map((item) => {
				let itemMap = {
					...this.getData(item),
					html: item
				}
				// if item doesnt have a weight, we'll give it one
				if(!itemMap.weight) itemMap.weight = 999
				itemMap.visible = this.checkVisibility(itemMap.facets, itemMap.content)
				return itemMap;
			})
			return this.weightedSort ? items.sort((a,b) => a.weight - b.weight) : items
		},
		useFormGroupings() {
			return this.$root.formGrouping == "true";
		},
	},
	methods: {
		...mapMutations(["setFormTypes"]),
		getData(html) {
			const data = {facets: null, content: null, formType: null, nodeGuid: null};
			let item = document.createElement("div");
			item.innerHTML = html.trim();
			item = item.firstChild;
			data.facets = JSON.parse(item.dataset.facets);
			data.content = item.textContent;
			data.formType = item.dataset.formType;
			data.weight = item.dataset.weight;
			data.nodeGuid = item.dataset.nodeGuid;
			return data;
		},
		checkVisibility(facets, content) {
			const facetMatch = this.model.every((selection, i) => {
				let facetsIncludeSelection;
				if (!selection) return true;
				else if (facets[i] === selection) return true;
				else {
					facetsIncludeSelection = facets.some(facet => {
						return facet == selection
					});
					return facetsIncludeSelection;
				}
			});
			const searchMatch = this.search ? content.toLowerCase().includes(this.search.toLowerCase()) : true;
			return facetMatch && searchMatch;
		},
		matchesType(item, type) {
			let typeSingular = type.slice(0, type.length - 1);
			if (item.formType === type || item.formType == typeSingular) return true
			else if ((item.formType == "" || item.formType == undefined) && type == "Other") return true
		},
		groupEmpty(type) {
			let typeSingular = type.slice(0, type.length - 1);
			let newArr = this.listing.filter(item => {
				if ((item.formType == "" || item.formType == undefined) && type == "Other") return item;
				else return item.formType == type || item.formType == typeSingular;
			});
			return newArr.every(item => {
				return !item.visible;
			})
		},
		loadFormTypes() {
			let newArr = ["Informational Documents", "Applicable Forms"]; 
			this.listing.forEach(item => {
				if (!newArr.includes(item.formType) && item.formType !== "Informational Document" && item.formType !== "Applicable Form") {
					newArr.push(item.formType);
				} else if (item.formType == "Informational Document") {
					item.formType = "Informational Documents";
				} else if (item.formType == "Applicable Form") {
					item.formType = "Applicable Forms";
				}
			});
			let arrContainsEmpties = newArr.some(item => item === "" || item == undefined);
			newArr = newArr.filter(item => item != '' && item != undefined);
			if (arrContainsEmpties) newArr.push("Other");
			this.setFormTypes(newArr);
		},
		removeDuplicates() {
			const items = [...this.$el.querySelectorAll("a.link-list")];
			const guids = [];
			items.forEach(item => {
				if (!guids.includes(item.getAttribute("data-node-guid"))) {
					guids.push(item.getAttribute("data-node-guid"));
				} else {
					item.closest(".filtering__item").remove();
				}
			});
		},
	},
	created() {
		this.loadFormTypes();
	},
	mounted() {
		this.removeDuplicates();
	}
};
</script>

<style lang="scss">
.filtering__items {
	position: relative;
}
.filtering__group {
	&:not(:last-child) {
		margin-bottom: 1.5rem;
	}
}
.filtering__form-type {
	margin-top: 2rem;
}
</style>